<template>
  <Popover
    ref="popover"
    v-bind="$attrs"
    :pt="{
      content: {
        class: [padding],
      },
    }"
  >
    <slot />
  </Popover>
</template>

<script setup>
  import Popover from "primevue/popover";
  import { ref } from "vue";

  const popover = ref();

  defineExpose({
    popover,
    toggle: (event) => popover.value.toggle(event),
    hide: (event) => popover.value.hide(event),
    show: (event) => popover.value.show(event),
  });

  defineProps({
    padding: {
      type: String,
      default: "",
    },
  });
</script>
